/**
 * 檔案用途區塊
 * @module ZaloLogin
 * @purpose 負責啟動 Zalo 第三方登入流程，組合 SSO 參數後以 replace 導向登入頁，避免返回再次觸發流程。
 * @external https://innotech.atlassian.net/browse/IN-93752
 * @external https://innotech.atlassian.net/browse/IN-54243
 * @external https://innotech.atlassian.net/browse/IN-54205
 * @external https://innotech.atlassian.net/browse/IN-52139
 * @external https://innotech.atlassian.net/browse/IN-52157
 */
import React, { useEffect } from 'react';
import { useThirdPartyProvider } from '@shared/models';
import { getSsoUrl } from '@utilities/helpers/ssoUrl.helper';
import { Page } from '@shared/enums/route.enum';

/**
 * 宣告內容用途說明與單號關聯
 * @description 定義 Zalo 登入頁元件，載入後立即執行導向登入流程。
 * @purpose 將第三方登入資料與導向時機封裝於單一元件，供路由節點直接掛載使用。
 * @external https://innotech.atlassian.net/browse/IN-54243
 */
const ZaloLogin = () => {
  /**
   * 宣告內容用途說明與單號關聯
   * @description 從第三方 Provider 狀態取得登入所需 payload。
   * @purpose 提供 clientId 與 redirectUrl 給 SSO URL 組裝流程使用。
   * @external https://innotech.atlassian.net/browse/IN-54243
   */
  const { payload } = useThirdPartyProvider();

  /**
   * 宣告內容用途說明與單號關聯
   * @description 建立並觸發 Zalo SSO 導向。
   * @purpose 使用目前 payload 組出 SSO URL，並以 location.replace 執行頁面跳轉。
   * @external https://innotech.atlassian.net/browse/IN-54243
   */
  const login = () => {
    location.replace(
      getSsoUrl(Page.Zalo, {
        clientId: payload.clientId!,
        redirectUrl: payload.redirectUrl!,
      }),
    );
  };

  useEffect(() => login());

  return <></>;
};

export default ZaloLogin;

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:19:14.623Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section annotation layout (top/middle/bottom), inserted declaration-level comments tied to provided declaration origins (IN-54243), converted all @external tags to full Jira browse URLs, deduplicated ticket links in the top block, and kept runtime logic unchanged.
 */
